import React from 'react';
import { Row, Col, Button, notification, Checkbox } from 'antd';
import { get, patch } from '../../../utils'; 
import { connect } from 'react-redux';
import homeSwipeOne from '../../../resource/screen-mobile/home-swipe/home-swipe-one.png'
import homeSwipeTwo from '../../../resource/screen-mobile/home-swipe/home-swipe-two.png'


const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description,
    });
};

class HomeSwiperScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            settingScreenMobileId: null,
            homeSwipe: 1,
            homeSwipeList: [
                { value: 2, name: 'Home Swipe One', image: homeSwipeOne },
                { value: 1, name: 'Home Swipe Two', image: homeSwipeTwo },
                { value: 3, name: 'Home Swipe Three', image: homeSwipeTwo, isTechnicianApp:true },
            ],
        }
    }

    getSettingScreenMobile() {
        let url = '/api/crm/administrator/setting/screen/mobile';
        get(url)
            .then(response => {
                this.setState({
                    settingScreenMobileId: response.id,
                    homeSwipe: response.home_swiper
                })
            })
            .catch(err => {
                console.log(err.message)
            })
    }

    componentDidMount() {
        this.getSettingScreenMobile()
    }


    updateSettingScreenMobile() {
        const { settingScreenMobileId, homeSwipe } = this.state
        let url = '/api/crm/administrator/setting/screen/mobile/' + settingScreenMobileId + '/home/swipe';
        let data = { home_swipe: homeSwipe }
        patch(url, data)
            .then(response => {
                openNotificationWithIcon('success', 'System notification', 'Save setting screen mobile home swipe success.')
            })
            .catch(err => {
                console.log(err.message)
            })
    }

    onClickOk() {
        this.updateSettingScreenMobile()
    }
    onClickCancel() {
        this.getSettingScreenMobile()
    }


    updateHomeSwiper(value) {
        this.setState({ homeSwipe: value })
    }

    getRoleEnabled() {
        const { roleDetail } = this.props
        if (roleDetail) {
            let index = roleDetail.findIndex(item => item.key === 'mobile')
            if (index != -1) {
                return roleDetail[index].edit
            }
            return false
        }
        return false
    }

    render() {
        const { homeSwipeList } = this.state
        let data = homeSwipeList.filter(item=>{
            if(this.props.mainCustomerId !=5 && item.isTechnicianApp){
                return false
            }
            return true
        })
        return (
            <div >
                <Row >
                    <Col span={12} style={{ textAlign: 'left' }}>
                    </Col>
                    <Col span={12} style={{ textAlign: 'right' }}>
                        <Button
                            style={{
                                marginLeft: 2, marginRight: 2,
                                backgroundColor: this.getRoleEnabled() ? '#ffffff' : '#BFBFBF',
                                color: this.getRoleEnabled() ? 'rgb(72, 197, 235)' : '#ffffff',
                                border: this.getRoleEnabled() ? '1px solid rgb(72, 197, 235)' : '#ffffff',
                            }}
                            disabled={!this.getRoleEnabled()}
                            onClick={() => this.onClickCancel()}
                        >
                            {'Cancel'}
                        </Button>
                        <Button
                            style={{
                                marginLeft: 2, marginRight: 2,
                                backgroundColor: this.getRoleEnabled() ? 'rgb(72, 197, 235)' : '#BFBFBF',
                                color: this.getRoleEnabled() ? '#ffffff' : '#ffffff',
                                border: this.getRoleEnabled() ? '1px solid rgb(72, 197, 235)' : '#ffffff',
                            }}
                            disabled={!this.getRoleEnabled()}
                            onClick={() => this.onClickOk()}
                        >
                            {'Save'}
                        </Button>
                    </Col>
                </Row>
                <div className="mobile-screen-content-wrapper">
                    {data.map(item => {
                        return (
                            <div className="item-mobile-screen-wrapper">
                                <Checkbox
                                    className='item-mobile-screen-checkbox-wrapper'
                                    checked={item.value == this.state.homeSwipe}
                                    onChange={() => this.updateHomeSwiper(item.value)}
                                />
                                <div
                                    className='item-mobile-screen-image-wrapper'
                                    onClick={() => this.updateHomeSwiper(item.value)}
                                >
                                    <img
                                        src={item.image}
                                        className='item-mobile-screen-image'
                                        style={{ border: item.value == this.state.homeSwipe ? '4px solid #48c5eb' : 'none' }}
                                    />
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    mainCustomerId: state.login.mainCustomerId,
    roleDetail: state.role.roleDetail,
})

export default connect(mapStateToProps, null)(HomeSwiperScreen);
